// @flow
import React from 'react';

import { withTheme } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import ListItem from '@material-ui/core/ListItem';
import MenuItem from '@material-ui/core/MenuItem';
import { withTranslation } from 'react-i18next';
import { ListItemIcon } from '@material-ui/core';
import SettingsVoiceOutlinedIcon from '@material-ui/icons/SettingsVoiceOutlined';
import { getSnack } from '../../utils/snackbar';
import { isInternalAudio, ONLY_INTERNAL_AUDIO_MIC_ID } from '../../utils/internalAudio';
import AvaMic from '../../components/Icons/AvaMic';

import LocalStorage, { STORAGE_KEYS } from '../../services/localStorage';

type Props = {
  micIdSelected: string,
  availableMics: Array<any>,
  setMicSelected: Function,
  t: Function,
  setOnlyInternalAudio: Function,
};

type State = {};

class MicSelector extends React.Component<Props, State> {
  handleChange = event => {
    const { setMicSelected, t, setOnlyInternalAudio } = this.props;
    LocalStorage.set(STORAGE_KEYS.SELECTED_MIC_ID, event.target.value);

    setMicSelected(event.target.value, () => {
      getSnack(this.props)(t('macInternalAudio.enabling'));
    });

    setOnlyInternalAudio(event.target.value.includes(ONLY_INTERNAL_AUDIO_MIC_ID));
  };

  handleClick = () => {
    if (navigator.mediaDevices) {
      navigator.mediaDevices.getUserMedia({ audio: true });
    }
  };

  componentDidUpdate(prevProps) {
    const { availableMics: prevAvailableMics } = prevProps;
    const { availableMics, setMicSelected, micIdSelected } = this.props;
    if (availableMics.length - prevAvailableMics.length === 1) {
      let newMicValue;
      availableMics.forEach(newMic => {
        let micFound = false;
        prevAvailableMics.forEach(prevMic => {
          if (prevMic.value === newMic.value) {
            micFound = true;
          }
        });
        if (!micFound && !isInternalAudio(newMic)) {
          newMicValue = newMic.value;
        }
      });

      const currentMic = prevAvailableMics.find(m => m.value === micIdSelected);

      if (isInternalAudio(currentMic)) {
        // We do nothing as we want to stay on "Ava Mic"
      } else if (newMicValue) {
        setMicSelected(newMicValue);
      }
    }
  }

  render() {
    const { micIdSelected, availableMics } = this.props;
    if (!micIdSelected) {
      return <div />;
    }
    const selectedMic = availableMics.find(mic => mic.value === micIdSelected);
    if (!selectedMic || !selectedMic.label) {
      return <div />;
    }

    return (
      <div>
        <ListItem key="mic_selected" role={undefined} dense>
          <ListItemIcon>
            <SettingsVoiceOutlinedIcon />
          </ListItemIcon>
          <Select
            value={micIdSelected}
            onChange={this.handleChange}
            style={{ overflow: 'hidden', width: '100%' }}
            disabled={selectedMic && availableMics.length < 2}
          >
            {availableMics.map(x => (
              <MenuItem key={x.value} value={x.value}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  {isInternalAudio(x) && <AvaMic style={{ marginRight: 10 }} />}
                  <span>{isInternalAudio(x) ? 'Ava Mic' : x.label}</span>
                </span>
              </MenuItem>
            ))}
          </Select>
        </ListItem>
      </div>
    );
  }
}
export default withTranslation()(withTheme(MicSelector));
